import { Flex, layout, Span, styled, Input, RoundButton } from '@fareye/ui'
import { startCase, FaPencilAlt } from '@fareye/utils'
import React from 'react'
import { UpdateAlertStatusButton } from './UpdateAlertStatusButton'

const ColFullHeight = styled((props: any) => (
  <Flex
    p={2}
    justifyContentSpaceEvenly
    alignItemsFlexStart
    column
    {...props}
    style={{ height: '100%', overflow: 'hidden' }}
  >
    {props.children}
  </Flex>
))`
  ${layout}
`
function generateSettingsColumn(original: any, columnName: string, { t }: any) {
  var value = original.settings[columnName]
  if (['state', 'status', 'inState'].includes(columnName)) {
    if (Array.isArray(value)) {
      value = t?.(value.join(','))
    }
    value = t?.(value)
  }
  return (
    <ColFullHeight data-testid={`settings.${columnName}`}>
      <Span>{original.settings ? value : ''}</Span>
    </ColFullHeight>
  )
}

export function getTableColumns(
  reqdColumns: any,
  selectedAlert: any,
  setSelectedAlert: (val: any) => void,
  propsConfig?: any
) {
  const result = reqdColumns.map((column: string) =>
    generateTableColumns(column, selectedAlert, setSelectedAlert, propsConfig)
  )
  return result
}

export function generateTableColumns(
  columnKey: string,
  selectedAlert: any,
  setSelectedAlert: (val: any) => void,
  propsConfig?: any
) {
  const { t, deleteAlert, setEditingAlert } = propsConfig
  switch (columnKey) {
    case 'radio':
      return {
        Header: t('Select'),
        id: 'radio',
        width: 100,
        filterable: false,
        sortable: false,
        Cell: ({ row: { original } }: any) => {
          return (
            <Input
              readOnly
              checked={original.id === selectedAlert?.id}
              name="radio"
              type="radio"
              id="radio"
            />
          )
        }
      }
    case 'users':
      return {
        Header: t('Users'),
        id: 'users',
        minWidth: 150,
        filterable: false,
        sortable: false,
        Cell: ({ row: { original } }: any) => (
          <ColFullHeight data-testid="alert_users.full_name">
            <Span>
              {original.alert_users.map((ele: any) => ele.full_name).join(', ')}
            </Span>
          </ColFullHeight>
        )
      }
    case 'providers':
      return {
        Header: t('Providers'),
        id: 'providers',
        minWidth: 150,
        filterable: false,
        sortable: false,
        Cell: ({ row: { original } }: any) => (
          <Span data-testid="providers.name">
            {original.providers.map((ele: any) => t(ele.name)).join(', ')}
          </Span>
        )
      }
    case 'is_consolidated':
      return {
        Header: t('Is Consolidated'),
        id: 'is_consolidated',
        minWidth: 150,
        filterable: false,
        sortable: false,
        Cell: ({ row: { original } }: any) => (
          <ColFullHeight data-testid="is_consolidated">
            <Span>{original.is_consolidated ? t('Yes') : t('No')}</Span>
          </ColFullHeight>
        )
      }
    case 'enableDisable':
      return {
        Header: t('Action'),
        id: 'enableDisable',
        minWidth: 100,
        filterable: false,
        sortable: false,
        Cell: ({ row: { original } }: any) => (
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              gap: '6px',
              padding: '4px'
            }}
          >
            {setEditingAlert && (
              <RoundButton
                title={t('Edit')}
                variant={'primary s'}
                style={{
                  boxShadow: '0 1px 2px 1px rgba(0,0,0,0.3)',
                  margin: 0,
                  transition: '0.2s ease'
                }}
                onClick={() => {
                  setEditingAlert(original)
                  window.scrollTo({ top: 0, behavior: 'smooth' })
                }}
              >
                <FaPencilAlt />
              </RoundButton>
            )}
            <UpdateAlertStatusButton
              setSelectedAlert={setSelectedAlert}
              selectedAlert={selectedAlert}
              alert={original}
              config={deleteAlert}
            />
          </div>
        )
      }
    default:
      return {
        Header: t(startCase(columnKey)),
        id: columnKey,
        minWidth: 150,
        filterable: false,
        sortable: false,
        Cell: ({ row: { original } }: any) =>
          generateSettingsColumn(original, columnKey, { t })
      }
  }
}
